module.exports = __webpack_public_path__ + "img/five-color-selected.442bd4cb.png";